var _span;
import PropTypes from 'prop-types';
import React from 'react';
import { Popup } from 'reaxl';

/**
 *  The VisitorsAgreement component is wrapped in a Popup component and takes a url string and passthrough props
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function VisitorsAgreement(_ref) {
  let {
    url,
    text = 'By using this service, you accept the terms of our ',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "visitorsAgreement",
    ...rest,
    children: [/*#__PURE__*/_jsx("span", {
      children: text
    }), /*#__PURE__*/_jsx(Popup, {
      height: 590,
      width: 650,
      url: url,
      children: _span || (_span = /*#__PURE__*/_jsx("span", {
        className: "text-link",
        children: "Visitor Agreement"
      }))
    })]
  });
}
export default VisitorsAgreement;